<template>
  <div
    :page="pagepos"
    :ratio="imgRatio"
    :mleft="left"
    @click="openEditorPosition($event)"
    ref="container"
    class="selectContainer ocr-container"
    :class="[
      {
        ocrPointer: OCREnabled && !finished,
        zoomPointer: zoomMode,
        'cursor-marker': getAddExtensType == 'marker',
        'cursor-link': createLinksMode,
      },
      cursorClass,
    ]"
    :style="style"
    @mousedown.left="startCropping"
    @mouseup.left="stopCropping"
    @mousemove="doCropping"
    @touchstart="startCropping"
    @touchend="stopCropping"
    @touchcancel="stopCropping"
    @touchmove="doCropping"
  >
    <BaseCleanPopup
      v-body
      :h="37"
      v-zindex
      v-if="showEditor"
      :winh="hUserExtens"
      :winw="wUserExtens"
      @mouseenter="setGrab(false)"
      @mouseleave="setGrab(true)"
      @close="closeAllExtens"
      :noneOverlay="true"
    >
      <template v-slot:header>
        <div class="flex-center-vh">
          {{
            addExtensType == "comment"
              ? $t("comments.comment")
              : addExtensType == "link"
              ? $t("links.link")
              : $t("keys.key")
          }}
        </div>
      </template>
      <add-user-exten
        :book="bookId"
        :tabId="tabId"
        v-if="addExtensType == 'comment'"
        @close="showEditor = false"
        :note="editorItem"
        :edit="true"
        @delete="deleteComment"
      />
      <add-user-key
        :book="bookId"
        :tabId="tabId"
        v-else-if="addExtensType == 'key'"
        @close="showEditor = false"
        :item="editorItem"
        :edit="true"
        @delete="deleteKey"
      />
      <add-user-link
        :book="bookId"
        :tabId="tabId"
        v-else-if="addExtensType == 'link'"
        @close="closeAllExtens"
        :item="editorItem"
        :edit="true"
        @delete="false"
        @gotoitempage="(item) => goToLink(item)"
      />
    </BaseCleanPopup>
    <template v-if="true || !isErrorImage">
      <!--  Shas Sections -->
      <template v-for="section in shasSections()">
        <shasSubSection
          v-show="isMefoOn"
          v-for="row in section.rects"
          :key="row.id"
          :section="section"
          :row="row"
          @mouseenter="addClassToThisShasSec = section.id"
          @mouseleave="addClassToThisShasSec = -1"
          :style="shasRowStyle(row) + '; z-index:3;'"
          :secHover="section.id == addClassToThisShasSec"
          @selectShasSec="selectShasSec"
          :tabId="tabId"
          :page="pageData.position"
        >
        </shasSubSection>
      </template>
      <!-- Marei Mekomot -->
      <template
        v-if="!isMefo || !this.isMefoOn || String(tabId).startsWith('win_')"
      >
        <template v-for="mm1 of mmts">
          <div :key="mm1.id" style="z-index: 1">
            <div
              v-for="(m, i) of mm1.words"
              :key="i"
              :class="{
                'yesod-mm': mm1.type == 'yesod' && showMm,
                mm: true,
                mmPointer: !MMhideMode.link,
                mmHover: !MMhideMode.hover && mm1.id == addClassToThisMM,
                mmHover2:
                  !MMhideMode.hover &&
                  mm1.id == addClassToThisMM &&
                  mm1.type == 'list',
              }"
              @mouseenter="addClassToThisMM = mm1.id"
              @mouseleave="addClassToThisMM = -1"
              v-tooltip="mmTooltip(mm1)"
              :style="mmStyle(m.pos) + '; z-index:2;'"
              @click="MMhideMode.link || openMm(mm1)"
            ></div>
          </div>
        </template>
      </template>
    </template>
    <template v-if="!isErrorImage && pageLoaded">
      <baseIconExtensOnPage
        type="marker"
        class="icon-marker marker"
        v-for="item of listMarker"
        :key="item.id"
        :id="item.id"
        :item="item"
        :style="markerStyleFromPx(item)"
        @click="removeMarker(item.id)"
        @dblclick.stop
      >
      </baseIconExtensOnPage>

      <baseIconExtensOnPage
        type="comment"
        class="icon-comment"
        v-for="item of listComment"
        :key="item.id + 'b'"
        :id="item.id"
        :item="item"
        :style="StyleFromPx(item)"
        @click.stop="openWin(item, 'comment', $event)"
        @dblclick.stop
        @dragStart="onDragStart"
        @dragEnd="onCommentDragEnd"
      >
      </baseIconExtensOnPage>

      <baseIconExtensOnPage
        type="key"
        class="icon-comment op1"
        v-for="item of listKey"
        :key="item.id + 'b'"
        :id="item.id"
        :item="item"
        @click.stop="openWin(item, 'key', $event)"
        @dblclick.stop
        :style="StyleFromPx(item)"
        @dragStart="onDragStart"
        @dragEnd="onKeyDragEnd"
      />

      <baseIconExtensOnPage
        v-zindex
        type="link"
        class="icon-comment op1"
        v-for="item of listLink"
        :key="item.id + 'link'"
        :id="item.id"
        :item="item"
        @click="goToLink(item.linkedTo)"
        :style="StyleFromPx(item)"
        @dragStart="onDragStart"
        @dragEnd="onLinkDragEnd"
      >
        <BaseContextMenu :noBubble="true">
          <div class="menu-item" @click="openWin(item, 'link', $event)">
            {{ $t("general.edit") }}
          </div>
          <div
            class="menu-item"
            @click="openInNewWin(item.linkedTo.bookId, item.linkedTo.position)"
          >
            {{ $t("itemBook1.openNewWindow") }}
          </div>
        </BaseContextMenu>
      </baseIconExtensOnPage>
    </template>

    <div
      class="cropper"
      :class="{
        'ocr-marker': finished || createMarkerMode,
        hide:
          (zoomMode && finishedZoomming) ||
          (!OCREnabled &&
            !zoomMode &&
            !$store.state.bookPopups.OCRResultsVisible),
      }"
      :style="cropperStyle"
    ></div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
// import addUserExten from "./addUserExten.vue";
const addUserExten = () => import("./addUserExten.vue");
import addUserKey from "./addUserKey.vue";
import addUserLink from "./addUserLink.vue";
import { fetchBookByID } from "@/services/loadBooksDataFromServer.js";
import shasSubSection from "@/components/mefo/shasSubSection.vue";
import mixBook from "@/mixing/mixBook.js";
import { Axios } from "@/services/_axios";
import mixMefo from "@/mixing/mixIsMefo";
let xMargin = 20,
  yMargin = 20;
export default {
  mixins: [mixBook, mixMefo],
  components: { addUserExten, addUserKey, addUserLink, shasSubSection },
  props: [
    "actualImgSize",
    "imageSize",
    "width",
    "height",
    "top",
    "left",
    "img",
    "imgRatio",
    "pageData",
    "tabId",
    "paddingTop",
    "webP",
    "fixedSize",
    "errorPage",
    "pagepos",
  ],
  data() {
    return {
      addClassToThisShasSec: 0,
      addClassToThisMM: 0,
      offsetEditor: {},
      cropperWidth: 0,
      cropperHeight: 0,
      cropperTop: 0,
      cropperLeft: 0,
      cropping: false,
      finished: false,
      finishedZoomming: true,
      startX: 0,
      startY: 0,
      cropX: 0,
      cropY: 0,
      // openEditors: [],
      showEditor: false,
      editorItem: null,
      showKeyWin: false,
      keyEditorItem: null,
      nameIconRemove: "x-list",
      OCR: "OCR ocr ocr",
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 0,
      blob: "",
      bookId: this.pageData.bookId,
      pageId: this.pageData.id,
      mmList: [],
      mmWinShow: false,
      pageLoaded: false,
    };
  },
  beforeDestroy() {
    //just in case
    window.removeEventListener("mouseup", this.stopCropping);
  },
  mounted() {
    this.$nextTick(() => {
      this.pageLoaded = true;
    });

    //manage open new comment
    let tempComment = this.$store.state.tabs[this.tabId].newComment;
    if (tempComment?.data && tempComment?.edit === true) {
      if (
        tempComment.item.bookId == this.pageData.bookId &&
        tempComment.item.name == this.pageData.name
      ) {
        this.setAddEtensType("comment");
        this.editorItem = tempComment.item;
        this.showEditor = true;
      }
    } else {
      //manage open new key
      let tempKey = this.$store.state.tabs[this.tabId].newKey;
      if (tempKey?.data && tempKey?.edit === true) {
        if (
          tempKey.item.bookId == this.pageData.bookId &&
          tempKey.item.name == this.pageData.name
        ) {
          this.setAddEtensType("key");
          this.editorItem = tempKey.item;
          this.showEditor = true;
        }
      }
    }
  },
  watch: {
    createBookSelect: function (val, oldVal) {
      this.setOCREnable(val);
    },
    initCropper: function (val, oldVal) {
      this.doInit();
    },
    OCRResultsVisible: function (val, oldVal) {
      if (!val) {
        this.finished = false;
        this.closeResults();
      }
    },
  },
  computed: {
    ...mapGetters("createBook", {
      createBookSelect: "getDrawOcrAction",
    }),
    ...mapState("personalAdditionsTabs", ["addingLink", "firstLink"]),
    // addingLink() {
    //   return this.$store.state[this.tabId].addingLink;
    // },
    // firstLink() {
    //   return this.$store.state[this.tabId].firstLink;
    // },
    ...mapGetters("bookPersonalExtensions", [
      "getUserCommentsListByPage",
      "getUserKeysListByPage",
      // "getUserLinksListByPage",
      "getAddExtensType",
      "getUserMarkerListByPage",
      "createKeyMode",
      "createCommentMode",
      "createMarkerMode",
      "createLinksMode",
      "crtExtentionsMode",
      "getOffset",
    ]),
    ...mapGetters("userSetting", [
      "showMm",
      "MMshowWithoutTooltip",
      "MMhideMode",
      "MMshowYesodOnly",
    ]),
    isMefoOn() {
      return this.$store.getters[`tabs/${this.tabId}/isMefoOn`];
    },
    isRectDrawingMode() {
      return this.OCREnabled || this.zoomMode;
    },
    zoomMode() {
      console.log(
        "this.$store.state.tabs[this.tabId].zoomMode",
        this.$store.state.tabs[this.tabId].zoomMode
      );

      return this.$store.state.tabs[this.tabId].zoomMode;
    },
    rotate() {
      return this.pageData?.rotate || 0;
    },
    landscape() {
      return this.rotate == 90 || this.rotate == 270;
    },
    ocrMode() {
      return this.userSettings.settings.book_selection_default &&
        this.userSettings.settings.book_selection_default == 1
        ? true
        : false;
    },
    getCurrentBook() {
      return this.$store.state.tabs[this.tabId].book;
    },
    getCurrentTabData() {
      return this.$store.getters[`tabs/${this.tabId}/getTabData`];
    },
    wUserExtens() {
      // return this.getAddExtensType == "comment" ? 380 : 240;

      switch (this.getAddExtensType) {
        case "comment":
          return 380;
          break;
        case "key":
          return 240;
          break;
        case "link":
          return 380;
          break;
      }
    },
    hUserExtens() {
      // return this.getAddExtensType == "comment" ? 330 : 240;
      switch (this.getAddExtensType) {
        case "comment":
          return 330;
          break;
        case "key":
          return 240;
          break;
        case "link":
          return 280;
          break;
      }
    },
    mmts() {
      let _vm = this;
      if (!this.imageSize.width) return []; //to be reactiv
      let imW = _vm.fixedSize.width;
      let imH = _vm.fixedSize.height;
      if (this.webP) {
        let rat = imW / 3000;
        imW = 3000;
        imH *= rat;
      }
      try {
        let mm =
          this.$store.state.tabs[this.tabId].MM[
            (this.pageData.originPosition || this.pageData.position) - 1
          ];
        if (this.MMshowYesodOnly) mm = mm.filter((m) => m.type == "yesod");
        // console.log(mm);
        return mm;
        let a = mm.filter((m) => {
          let out = false;
          m.words.forEach((w) => {
            if (
              w.pos.left + w.pos.width >= 100 ||
              w.pos.top + w.pos.height >= 100
            ) {
              out = true;
              return;
            }
          });

          return !out;
        });

        return a;
      } catch (error) {}
    },
    // shasSections() {
    //   //disable mef in window
    //   if (this.tabId.startsWith("win") || this.$store.state.bookOnlyMode)
    //     return [];
    //   if (!this.imageSize.width) return []; //to be reactiv
    //   let sections = [];
    //   try {
    //     sections = this.$store.state.tabs[this.tabId].SHAS_SECTIONS || {};
    //     sections = sections[this.pageData.position - 1] || [];
    //   } catch (ex) {}
    //   return sections;
    // },
    cursorClass() {
      return this.crtExtentionsMode ? this.getAddExtensType + "-cursor" : "";
    },
    OCRResultsVisible() {
      return this.$store.state.bookPopups.OCRResultsVisible;
    },
    addExtensType() {
      return this.getAddExtensType;
    },
    getPersonalAdditions() {
      return (
        this.$store.getters[`personalAdditionsTabs/getPersonalAdditions`][
          this.getCurrentBook
        ] || { comments: [], keys: [], markers: [], links: [] }
      );
    },
    listComment() {
      let a = this.getPersonalAdditions.comments.filter(
        (pa) => pa.pageId === this.pageData.id
      );
      return a;
      return this.getUserCommentsListByPage(this.pageData.id);
    },
    listKey() {
      return this.getPersonalAdditions.keys.filter(
        (pa) => pa.pageId === this.pageData.id
      );
      return this.getUserKeysListByPage(this.pageData.id);
    },
    listLink() {
      return this.getPersonalAdditions.links.filter(
        (pa) => pa && pa.pageId === this.pageData.id
      );
      let links = this.getUserLinksListByPage(this.pageData.id);
      return links;
    },
    listMarker() {
      //wait for image to be drawn to get origin size
      if (this.imageSize.width == undefined) return [];
      return this.getPersonalAdditions.markers.filter(
        (pa) => pa.pageId === this.pageData.id
      );
      return this.getUserMarkerListByPage(this.pageData.id);
    },
    isErrorImage() {
      return this.errorPage;
    },
    ...mapState("bookPopups", ["OCREnabled"]),
    zoomMode() {
      return this.$store.state.tabs[this.tabId].zoomMode;
    },
    cropperStyle() {
      return (
        "width: " +
        this.cropperWidth +
        "px;height:" +
        this.cropperHeight +
        "px;top:" +
        this.startY +
        "px;left:" +
        this.startX +
        "px"
      );
    },
    resultsStyle() {
      return "top:" + this.startY + "px";
    },
    styleCont() {
      return (
        "width: " +
        (this.width - this.left * 2 - 4) + //4px is because of padding in pageItem */
        "px;height:" +
        parseInt(this.height) +
        "px;top:20px;"
      );
    },
    style() {
      return (
        "width: " +
        (this.width - 4) + //4px is because of padding in pageItem
        /*         (this.width - this.left * 2 - 4) + //4px is because of padding in pageItem */
        "px;height:" +
        (parseInt(this.height) + (this.landscape ? 0 : 40)) +
        "px;top:0px;"
      );
    },
    initCropper() {
      this.blob = "";
      let init = this.$store.state["tabsManager"].initCropper;
      return init;
    },
  },
  methods: {
    ...mapActions("createBook", ["setOcrOutput"]),
    ...mapActions("bookPopups", ["setOCREnable", "setGrab"]),
    ...mapActions("bookPersonalExtensions", [
      "setExtenPage",
      "setOffset",
      "setAddEtensType",
      "stopCreatModeAllExtantions",
      "setModeEdit",
      "closeExtens",
    ]),
    ...mapActions("personalAdditionsTabs", [
      "addNewLink",
      "secondLinksFinished",
    ]),
    ...mapActions("userPersonalExtensions", [
      "deleteUserComment",
      "deleteUserKey",
      "deleteUserMarker",
      "updateUserComment",
    ]),
    shasSections() {
      //disable mef in window
      // if (this.tabId.startsWith("win") /*  || this.$store.state.bookOnlyMode */)

      if (this.tabId.startsWith("win") || this.$store.state.bookOnlyMode)
        return [];
      if (!this.imageSize.width) return []; //to be reactiv
      let sections = [];
      try {
        const fn =
          this.$store.getters["tabs/" + this.tabId + "/getMefoSectionsList"];

        const sectionList = fn(
          this.$store.state.tabs[this.tabId].SHAS_SECTION_LIST_ID
        );

        // getMefoSectionsList(this.$store.state.tabs[this.tabId].SHAS_SECTION_LIST_ID)
        sections = sectionList || {};
        sections = sections[this.pageData.position - 1] || [];
      } catch (ex) {}
      return sections;
    },
    onDragStart() {
      this.$store.state.bookPersonalExtensions.dragging = true;
      this.setOCREnable(false);
    },
    onLinkDragEnd(left, top, event, item) {
      this.$store.state.bookPersonalExtensions.dragging = false;
      this.setOCREnable(this.ocrMode);
      let { x, y } = this.getPositionPerImage(left, top);

      let userLink = {
        id: item,
        x,
        y,
      };

      this.$store.dispatch(
        `personalAdditionsTabs/updLinkPos`,
        { bookId: this.getCurrentBook, userLink },
        {
          root: true,
        }
      );
    },
    onKeyDragEnd(left, top, event, item) {
      this.$store.state.bookPersonalExtensions.dragging = false;
      this.setOCREnable(this.ocrMode);
      let { x, y } = this.getPositionPerImage(left, top);

      let editKey = {
        id: item,
        x,
        y,
      };

      this.$store.dispatch(
        `personalAdditionsTabs/updKey`,
        { bookId: this.getCurrentBook, editKey },
        {
          root: true,
        }
      );
    },
    onCommentDragEnd(left, top, event, item) {
      this.$store.state.bookPersonalExtensions.dragging = false;
      this.setOCREnable(this.ocrMode);
      let { x, y } = this.getPositionPerImage(left, top);

      let editKey = {
        id: item,
        x,
        y,
      };

      this.$store.dispatch(
        `personalAdditionsTabs/updComment`,
        { bookId: this.getCurrentBook, editKey },
        {
          root: true,
        }
      );
    },
    async selectShasSec(data) {
      const section = data.section;
      const addit = data.addIt;
      const currentSec =
        this.$store.state.tabs[this.tabId].shasSecSelected || [];
      const payload = { add: addit, section };
      let showLoading = true;
      if (payload.add) {
        //check in the list
        const had = currentSec.find((a) => a.id && a.id == section?.id);
        if (had) showLoading = false;
      } else {
        //check if its only one and its
        if (currentSec.length == 1 && currentSec[0].id == section?.id)
          showLoading = false;
      }
      if (showLoading) this.$store.dispatch("mefo/setLoading", true);
      //if this is net we need to connect first (ot it least check i f we conneted)
      if (
        globalThis.OTZAR_BASIC_INFO.networkMode != "off" &&
        this.pageData.position > this.$store.state.tabs[this.tabId].mefFirstPage
      ) {
        //this is net
        let ret = await Axios.get("/api/network/mef-connect");
        ret = ret.data;
        if (ret == "connected") {
          this.$store.dispatch(`mefo/setNoSpace`, false);
          this.$store.dispatch(`mefo/setConnected`, true);
          this.$store.dispatch(`mefo/setKickOut`, false);
          this.$store.dispatch(
            `tabs/${this.tabId}/setShasSecSelected`,
            payload
          );
        } else if (ret == "no_space") {
          this.$store.dispatch(`mefo/setKickout`, false);
          this.$store.dispatch(`mefo/setNoSpace`, true);
        }
      } else {
        this.$store.dispatch(`mefo/setNoSpace`, false);
        this.$store.dispatch(`mefo/setKickOut`, false);
        this.$store.dispatch(`tabs/${this.tabId}/setShasSecSelected`, payload);
      }

      this.$store.dispatch(`mefo/setShowMefoArea`, true);

      /*
      if (this.$_mobile) {
             this.$store.dispatch(`mefo/setCurrentShasSectionId`, section);
      this.$store.dispatch(`mefo/setCurrentShasId`, this.getCurrentBook);
        this.$store.state.mobile.tab = "MEF_LIST";
      } */
    },
    openEditorWin() {
      this.$store.dispatch(`personalAdditionsTabs/openEditorWin`);
    },
    markerStyleFromPx(item, calcWebP = false) {
      let position = this.getContainerPositionsFromPX(item, calcWebP);
      if (position == 0) return "";
      let style = `width:${position.width}%;height:${position.height}%;top:${position.y}%;left:${position.x}%;`;

      return style;
    },
    StyleFromPx(item, calcWebP = false) {
      let position = this.getContainerPositionsFromPX(item, calcWebP);
      if (position == 0) return "";
      let style = `top:${position.y}%;left:${position.x}%;`;

      return style;
    },
    markerStyle(item) {
      let position = this.getContainerPositionsFromPercent(item);
      if (position == 0) return "";
      let style = `width:${position.width}%;height:${position.height}%;top:${position.y}%;left:${position.x}%;`;
      return style;
    },
    shasRowStyle(row) {
      //round
      let { x, y, h, w } = row;

      w = this.imageSize.width * w;
      h = this.imageSize.height * h;
      x = this.imageSize.width * x;
      y = this.imageSize.height * y;

      let position = this.getContainerPositionsFromPX(
        { width: w, height: h, x, y },
        true
      );

      w = String(position.width).slice(0, 5);
      h = String(position.height).slice(0, 5);
      x = String(position.x).slice(0, 5);
      y = String(position.y).slice(0, 5);

      let style = `width:${w}%;height:${h}%;top:${y}%;left:${x}%;`;
      return style;
    },

    mmStyle(item) {
      let rects = { ...item, x: item.left, y: item.top };
      return this.markerStyleFromPx(rects, true);
    },

    async openMm(books) {
      books = books.books;
      try {
        const morebooks = books
          .map((b) => {
            const additionalInfo = this.getBookbyId(b.bookId);
            if (additionalInfo !== undefined) {
              return {
                ...additionalInfo,
                ...b,
              };
            }
            return null;
          })
          .filter((book) => book !== null);

        const rgx1 = /[^a-zA-Zא-ת]/;
        const sortedBooks = morebooks.sort((a, b) => {
          const scoreA = a.score || 0;
          const scoreB = b.score || 0;

          const scoreComparison = scoreB - scoreA;
          if (scoreComparison !== 0) {
            return scoreComparison;
          }

          const AauthName = a.authors_0_name ? a.authors_0_name : "";
          const BauthName = b.authors_0_name ? b.authors_0_name : "";
          const Bfromyear = b.fromyear ? b.fromyear : "";
          const Afromyear = a.fromyear ? a.fromyear : "";
          // If scores are equal, then compare by author name
          const authorComparison = AauthName.replace(rgx1, "").localeCompare(
            BauthName.replace(rgx1, "")
          );
          if (authorComparison === 0) {
            // If authors are the same, then compare by from year
            return Bfromyear.replace(rgx1, "").localeCompare(
              Afromyear.replace(rgx1, "")
            );
          }
          // If authors are different, return the result of the author comparison
          return authorComparison;
        });
        //////////////////////////////////////////////////////////////////////
        let page;
        if (sortedBooks[0].positionPage) {
          page = sortedBooks[0].positionPage ? sortedBooks[0].positionPage : 1;
          this.openInNewWin(
            sortedBooks[0].id,
            page,
            null,
            null,
            null,
            sortedBooks
          );
        } else {
          if (this.MMhideMode.link) return;
          const bookOnlyMode = this.$store.state.bookOnlyMode;
          let book = books[0];
          if (bookOnlyMode) {
            for (let i = 0; i < books.length; i++) {
              let bookDetails = await fetchBookByID(books[i].bookId);
              if (bookDetails) {
                books[i] = {
                  bookId: bookDetails.id,
                  ...bookDetails,
                  ...books[i],
                };
              }
            }
          } else {
            page = book.pageName ? "PID_" + book.pageName : 1;
          }
          this.openInNewWin(
            sortedBooks[0].id,
            page,
            null,
            null,
            null,
            sortedBooks
          );
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    getMmBookName(mm) {
      try {
        let bookId = mm.books[0].bookId;
        let book = this.getBookbyId(bookId);
        return book.name.replace(/ ?<.+>/, "");
      } catch (error) {
        return "";
        let bookId = mm.books[0].bookId;
        let book = this.getBookbyId(bookId);
      }
    },
    getBookbyId(bookId) {
      let book = this.$store.getters["books/getBookbyId"](bookId);

      return book;
    },
    mmTitle(mm) {
      // let level = `<div class='precise${mm.level}'></div> `;
      let x;
      if (mm.level == 1 || 1 + 1 == 2) {
        x = this.$t("mm.mmToltipAccuracyH");
      } else if (mm.level == 2) {
        x = this.$t("mm.mmToltipAccuracyM");
      } else x = this.$t("mm.mmToltipAccuracyL");
      let level = `<div class="relative" style="padding:3px 2px 5px ">
          <div class=""></div>
          <div class="flex flex-align-center  a-right rtl" style="direction:rtl;text-align:right">
            <span class="precise${mm.level}"></span>
            <span>${mm.str}</span>
          </div>
        </div> `;

      return mm.level ? level : this.getMmBookName(mm);
    },
    mmTooltip(mm1) {
      return this.MMhideMode.tooltip || this.MMshowWithoutTooltip
        ? ""
        : {
            content: this.mmTitle(mm1),
            placement: "bottom",
            classes: "extens-tooltip",
          };
    },
    goToLink(link) {
      if (link.bookId == this.getCurrentBook) {
        this.go(link.position, this.tabId);
      } else {
        this.openInNewWin(link.bookId, link.position);
      }
    },
    closeAllExtens() {
      this.$store.state.tabs[this.tabId].newComment = {};
      this.$store.state.tabs[this.tabId].newKey = {};
      this.showEditor = false;
      this.closeExtens();
    },
    getContainerPositionsFromPX(rects, calcWebP) {
      let imgW = this.fixedSize.width;
      let imgH = this.fixedSize.height;
      // let imgW = !extens ? this.fixedSize.width : this.sizeForExtens.width;
      // let imgH = !extens ? this.fixedSize.height : this.sizeForExtens.height;

      if (calcWebP && this.webP) {
        let fixRatio = 3000 / this.imageSize.width;
        imgW = imgW * fixRatio;
        imgH = imgH * fixRatio;
      }

      let xPX = rects.x / imgW;
      let yPX = rects.y / imgH;
      // let width = rects.width === undefined ? 0 : rects.width / imgW;
      // let height = rects.height === undefined ? 0 : rects.height / imgH;
      let width = rects.width / imgW;
      let height = rects.height / imgH;
      let container = this.$refs.container;
      if (container == undefined) return 0;
      let containerWidth = container.clientWidth;
      if (containerWidth == 0) return 0;
      let containerHeight = container.clientHeight;

      let marginV = 20;
      let imgWidth = this.actualImgSize.width;
      let imgHeight = this.actualImgSize.height;

      xPX = xPX * imgWidth;
      yPX = yPX * imgHeight;

      xPX += this.left + 10;
      yPX += marginV;

      let containerRatioW = containerWidth / this.actualImgSize.width;
      let containerRatioH = containerHeight / this.actualImgSize.height;

      let x = (xPX / containerWidth) * 100;
      let y = (yPX / containerHeight) * 100;
      width = (width / containerRatioW) * 100;
      height = (height / containerRatioH) * 100;

      return { x, y, width, height };
    },
    getContainerPositionsFromPercent(rects /** = { x, y, width, height } */) {
      let { x, y, width, height, containerWidth, containerHeight } =
        this.getContainerPositionsFromPercentInPx(rects);

      if (x == undefined) return 0;

      let selectAreaRatio = containerWidth / (containerWidth - xMargin);
      x = (x / containerWidth) * selectAreaRatio * 100;
      width = (width / containerWidth) * selectAreaRatio * 100;
      y = (y / containerHeight) * selectAreaRatio * 100;
      height = (height / containerHeight) * selectAreaRatio * 100;

      return { x, y, width, height };
    },

    getContainerPositionsFromPercentInPx({ x, y, width, height }) {
      let container = this.$refs.container;
      if (container == undefined) return 0;
      let containerWidth = container.clientWidth;
      if (containerWidth == 0) return 0;
      let containerHeight = container.clientHeight;
      let marginH = this.left * 2;
      let marginV = this.paddingTop * 2;
      let imgWidth = containerWidth - marginH;
      x *= imgWidth;
      x += this.left;

      width *= imgWidth;

      let imgHeight = containerHeight - 40 - marginV; // - marginV;
      y *= imgHeight;
      y += 20;

      height *= imgHeight;

      return { x, y, width, height, containerWidth, containerHeight };
    },
    getPositionsInPX(x, y, containerWidth, containerHeight) {
      let margins = this.left * 2;
      let outsideX = 0,
        outsideY = 0;
      let width = 0,
        height = 0;
      x = (x - this.left) / containerWidth;
      if (x < 0) {
        outsideX = x * -1;
        x = 0;
      }

      y = (this.startY - 20) / containerHeight;
      if (y < 0) {
        outsideY = y * -1;
        y = 0;
      }

      width = this.cropperWidth / containerWidth - outsideX;
      height = this.cropperHeight / containerHeight - outsideY;

      //convert to real positions in px on origin image
      x *= this.imageSize.width;
      width *= this.imageSize.width;
      y *= this.imageSize.height;
      height *= this.imageSize.height;

      return { x, y, width, height };
    },
    getPosInOriginPx(sx, sy) {
      if (!sx) sx = this.startX;
      if (!sy) sy = this.startY;

      let outsideX = 0,
        outsideY = 0;
      let xRatio = this.imageSize.width / this.actualImgSize.width;
      let yRatio = this.imageSize.height / this.actualImgSize.height;

      let x = sx - xMargin / 2 - this.left;
      if (x < 0) {
        outsideX = x * -1;
        x = 0;
      }

      let y = sy - 20;
      if (y < 0) {
        outsideY = y * -1;
        y = 0;
      }

      return {
        x: Math.round(x * xRatio),
        y: Math.round(y * yRatio),
        width: Math.round((this.cropperWidth - outsideX) * xRatio),
        height: Math.round((this.cropperHeight - outsideY) * yRatio),
      };
    },
    getRealPositions(x, y, containerWidth, containerHeight, calcSize = true) {
      let margins = this.left * 2;
      let outsideX = 0,
        outsideY = 0;
      let width = 0,
        height = 0;

      if (calcSize) {
        x = (x - this.left) / containerWidth;
        if (x < 0) {
          outsideX = x * -1;
          x = 0;
        }

        y = (this.startY - 20) / containerHeight;
        if (y < 0) {
          outsideY = y * -1;
          y = 0;
        }
        width = this.cropperWidth / containerWidth - outsideX;

        height = this.cropperHeight / containerHeight - outsideY;
      } else {
        x -= this.left;
        if (x < 0) x = 0;

        y -= 20;
        if (y < 0) y = 0;

        width = this.$refs.container.clientWidth - margins;
        height = this.$refs.container.clientHeight - 40;
      }

      return { x, y, width, height };
    },
    deleteComment() {
      this.$store.dispatch(
        `personalAdditionsTabs/delComment`,
        { bookId: this.getCurrentBook, keyId: this.editorItem.id },
        {
          root: true,
        }
      );
      this.$store.state.tabs[this.tabId].newComment = {};
      this.$store.state.tabs[this.tabId].newKey = {};
      // this.deleteUserComment(this.editorItem.id);
    },
    deleteKey() {
      this.$store.dispatch(
        `personalAdditionsTabs/delKey`,
        { bookId: this.getCurrentBook, keyId: this.editorItem.id },
        {
          root: true,
        }
      );
      //this.deleteUserKey(this.editorItem.id);
    },
    miniTitle() {
      return (
        this.$t(this.addExtensType + "s." + this.addExtensType) +
        " " +
        this.$t("general.new")
      );
    },
    openEditorPosition(e) {
      if (!this.crtExtentionsMode) return;
      this.setExtEventOffset(e);
      this.setExtenPage(this.pageData.id);

      this.$emit("addexten");
      if (this.createLinksMode) {
        if (!this.addingLink) {
          //add first link
          this.startAddLink();
          this.openEditorWin();
        } else {
          //add second link
          if (
            this.firstLink.bookId == this.getCurrentBook &&
            this.pageData.id == this.firstLink.pageId
          )
            return this.$notify({
              type: "error",
              message: this.$t("links1.notCreatCurrentPage"),
              timeout: 3000,
            });
          this.setSecondLink();
          this.stopCreatModeAllExtantions();
        }
      } else if (this.createCommentMode) {
        this.openEditorWin();
        this.stopCreatModeAllExtantions();
      } else if (this.createKeyMode) {
        this.openEditorWin();
        this.stopCreatModeAllExtantions();
      }
    },
    getPositionPerImage(x, y) {
      // let rect = e.target.getBoundingClientRect();
      let positionInPX = this.getPosInOriginPx(x, y);

      return { x: positionInPX.x, y: positionInPX.y };
    },
    setExtEventOffset(e) {
      let rect = e.currentTarget.getBoundingClientRect();

      let { x, y, width, height } = this.getRealPositions(
        e.clientX - rect.left,
        e.clientY - rect.top,
        0,
        0,
        false
      );

      let positionInPX = this.getPosInOriginPx(
        e.clientX - rect.left,
        e.clientY - rect.top
      );

      this.offsetEditor.percentX = (x / width) * 100;
      this.offsetEditor.percentY = (y / height) * 100;
      this.offsetEditor.x = x;
      this.offsetEditor.y = y;
      this.offsetEditor.xPx = positionInPX.x;
      this.offsetEditor.yPx = positionInPX.y;

      this.setOffset(this.offsetEditor);
    },
    removeMarker(id) {
      this.$store.dispatch(
        `personalAdditionsTabs/delMarker`,
        { bookId: this.bookId, userMarkerId: id },
        {
          root: true,
        }
      );
    },
    removeOpenWin(item) {
      // this.editorItem=item;

      this.openEditors = false; //this.openEditors.filter((i) => i != id);
    },
    startAddLink() {
      let payload = this.crtLinkDetails();
      this.addNewLink(payload);
    },
    setSecondLink() {
      let secondLink = this.crtLinkDetails();
      this.secondLinksFinished(secondLink);
    },
    crtLinkDetails() {
      return {
        bookId: this.getCurrentBook,
        pageId: this.pageData.id,
        x: this.getOffset.xPx,
        y: this.getOffset.yPx,
        bookName: this.getCurrentTabData.title,
        position: this.pageData.position,
        note: "",
        name: this.pageData.name,
        letter: this.pageData.pagedata[0]?.letter || "",
      };
    },

    openWin(item, type, event) {
      event.stopPropagation();
      this.setAddEtensType(type);

      this.editorItem = item;

      this.showEditor = true;
      // if (!this.openEditors.includes(id)) this.openEditors.push(id);
    },
    openEditorWindow(item, type) {
      // this.
      // let offset;
      // let x = (this.$refs.container.clientWidth * item.x) / 100 + 72;
      // let y = (this.$refs.container.clientHeight * item.y) / 100 + 80;
      // offset = { x: x, y: y };
      // this.setOffset(offset);
      // this.setAddEtensType(type);
      // this.setModeEdit(item);
      // this.openEditorWin();
    },

    reCalc() {
      var x3 = Math.min(this.x1, this.x2);
      var x4 = Math.max(this.x1, this.x2);
      var y3 = Math.min(this.y1, this.y2);
      var y4 = Math.max(this.y1, this.y2);
      this.startX = x3;
      this.cropperWidth = x4 - x3;
      this.startY = y3;

      this.cropperHeight = y4 - y3;
    },
    doInit() {
      this.finished = false;
      //this.setOCREnable(true);
      this.cropperWidth = 0;
      this.cropperHeight = 0;
      this.cropperTop = 0;
      this.cropperLeft = 0;
      this.cropping = false;
      this.OCR = "";
    },
    startCropping(event) {
      if (this.isRectDrawingMode) {
        this.finishedZoomming = false;
        window.addEventListener("mouseup", this.stopCropping);
        var rect = event.currentTarget.getBoundingClientRect();
        this.OCR = "";
        this.cropX = event.touches ? event.touches[0].clientX : event.clientX;
        this.cropY = event.touches ? event.touches[0].clientY : event.clientY;
        this.x1 =
          (event.touches ? event.touches[0].clientX : event.clientX) -
          rect.left;
        this.y1 =
          (event.touches ? event.touches[0].clientY : event.clientY) - rect.top;
        this.cropping = true;
      }
    },
    stopCropping() {
      if (this.isRectDrawingMode) {
        let margins = this.left * 2;
        let outsideX,
          outsideY = 0;
        window.removeEventListener("mouseup", this.stopCropping);
        this.cropping = false;

        /*  let imgRect = this.getRealPositions(
          this.startX - xMargin / 2,
          this.startY,
          this.$refs.container.clientWidth - this.left * 2,
          this.$refs.container.clientHeight - 40
        ); */

        //marker
        let pxRect = this.getPosInOriginPx();

        if (this.createMarkerMode) {
          this.closeAllExtens();
          this.closeResults();
          if (pxRect.width < 10 || pxRect.height < 10) return;
          let payload = {
            bookId: this.bookId,
            pageId: this.pageData.id,
            x: Math.round(pxRect.x),
            y: Math.round(pxRect.y),
            width: Math.round(pxRect.width),
            height: Math.round(pxRect.height),
            name: this.pageData.name,
            position: this.pageData.position,
            letter: this.pageData.pagedata[0]?.letter || "",
          };
          this.$store.dispatch(`personalAdditionsTabs/addMarker`, {
            bookId: this.bookId,
            userMarker: payload,
          });

          const notification = {
            type: "success",
            message: this.$t("links1.successCreateMarker"),
            timeout: 2000,
          };
          this.$notify(notification);
          return;
        }

        if (pxRect.width < 10 || pxRect.height < 10) return;

        let ocrRect = this.getRealPositions(
          this.startX - xMargin / 2,
          this.startY,
          this.$refs.container.clientWidth - this.left * 2,
          this.$refs.container.clientHeight - 40 - this.paddingTop * 2
        );

        let ocrRectInPx = Object.assign({}, pxRect);

        //fix coords for PDF books ( basis 3000 )
        if (this.webP) {
          let fixRatio = 3000 / this.imageSize.width;

          ocrRectInPx.x *= fixRatio;
          ocrRectInPx.width *= fixRatio;
          ocrRectInPx.y *= fixRatio;
          ocrRectInPx.height *= fixRatio;
        }

        let startX = this.startX - this.left - xMargin / 2;
        startX >= 0 ? startX : (startX = 0);
        this.$emit("toggleocr", {
          show: true,
          img: this.img,
          x: ocrRect.x,
          y: ocrRect.y,
          width: ocrRect.width,
          height: ocrRect.height,
          pageData: this.pageData,
          cWidth: this.cropperWidth,
          cHeight: this.cropperHeight,
          startX,
          startY: this.startY - 20,
          imgRatio: this.imgRatio,
          markerRect: pxRect,
          ocrRectInPx: ocrRectInPx,
          zoomMode: this.zoomMode,
        });
        if (this.zoomMode) this.finishedZoomming = true;
        this.finished = true;
        //ocr for user book
        if (this.createBookSelect) this.closeResults();

        this.x1 = this.x2 = this.y1 = this.y2 = 0;
      }
    },
    doCropping(event) {
      if (this.cropping) {
        var rect = event.currentTarget.getBoundingClientRect();
        this.x2 =
          (event.touches ? event.touches[0].clientX : event.clientX) -
          rect.left;
        this.y2 =
          (event.touches ? event.touches[0].clientY : event.clientY) - rect.top;
        this.reCalc();
      }
    },
    closeResults() {
      this.finished = false;
      this.setOCREnable(this.ocrMode);
      this.cropperWidth = 0;
      this.cropperHeight = 0;
      this.cropperTop = 0;
      this.cropperLeft = 0;
    },
    // goToItemPage(item, type) {},
  },
};
</script>
<style lang="scss">
$bg-color1: #fff;
$bg-color2: #f7f7f7;
.ocr-container {
  .icon-del {
    line-height: 20.3px;
  }
  .header {
    // display: flex;
    // height: 23px;
    // padding: 0 12px;
    // padding-right: 33px;
    // line-height: 23px;
    // font-size: 11px;
    // color: #000;
    // font-weight: 500;
    // background-color: #efefef;
    // justify-content: space-between;
    // position: relative;
    .ocr-win-header {
      position: absolute;
      right: 10px;
      top: 2px;
    }
    .x-close svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 11px;
    }
  }
  .buttons {
    padding: 0 12px;
  }
}
.selectContainer {
  opacity: 1;
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 50%;
  transform: translate(-50%);
}
.cropper {
  position: absolute;
  border: black dotted 1px;
}
.ocr-marker {
  border: 0 !important;
  background-color: lightblue;
  z-index: 1999;
  opacity: 0.5;
}
.hide {
  display: none !important;
}
.results {
  position: sticky;
  width: 556px !important;
  height: 287px !important;
  top: 10%;
  left: 30%;
  background-color: $bg-color1;
  z-index: 9999 !important;
  box-shadow: 10px 0 10px rgba(0, 0, 0, 0.16);
  // border: 1px solid #efefef;
  box-shadow: 0 2px 3px 1px #0000005c;
}
.inner-results {
  display: flex;
  flex-direction: row;
  background-color: $bg-color1;
  justify-content: space-between;
  padding: 19px 12px 0px 12px;
  textarea,
  .img-ocr {
    background-color: $bg-color2;
    border: 1px solid #dedede;
    width: 260px;
    height: 100%;
    overflow: auto;
    flex-grow: 1;
    color: #000;
    font-size: 14px;
  }
}
.icon {
  width: "20px";
  height: "20px";
  display: block;
}
.inline .icon {
  display: initial;
}
.buttons {
  display: flex;
  flex-direction: row;
}

.ocrPointer {
  cursor: crosshair;
  touch-action: none;
}
.zoomPointer {
  cursor: zoom-in;
  touch-action: none;
}
.icon-comment {
  position: absolute;
  display: block;
  width: 28px;
  height: 28px;
  background-color: var(--custom-color1);
  z-index: 4;
  opacity: 0.5;
  cursor: pointer !important;
}

// }

.mm {
  position: absolute;
  display: block;
  z-index: 1999;
  // padding: 0.15rem;
  // margin-left: -3px;
  // margin-top: -3px;
  box-sizing: content-box;
  background-color: transparent;
  // background-color: #05c67c20;
  transform: scaleX(1.1) scaleY(1.5);
  &.border-b {
    border-bottom: 2px solid var(--custom-color1);
    &.yesod-mm {
      border-bottom: 2px solid var(--custom-color2);
    }
  }
  &.yesod-mm {
    background-color: #504f4f10;
  }
  // border-radius: 1pc;
}
.mmPointer {
  cursor: pointer;
}
.mmPointer:active {
  // border: var(--custom-color3) solid 0.5px;
  background-color: var(--custom-color3);
  opacity: 0.9;
  // cursor: grabbing;
}
.mmHover {
  // border-bottom: 1px solid #140899 !important;
  background-color: var(--custom-color3);
}
.mmHover.yesod-mm {
  background-color: var(--custom-color3);
}
.mmHover2 {
  // border-bottom: 1px solid #57080fd2 !important;
}
</style>
